import {NgModule} from '@angular/core';
import {SharedModule} from '../../../core/shared.module';
import {ArticleListComponent} from './article-list.component';
import {UIRouterModule} from '@uirouter/angular';
import {InventoryModalModule} from '../inventory/inventory-modal.module';
import {ArticleListSpecFilterComponent} from './article-list-spec-filter.component';
import {ArticleWizardButtonModule} from '../article-wizard-button/article-wizard-button.module';

@NgModule({
  imports: [
    UIRouterModule.forChild(),
    SharedModule,
    InventoryModalModule,
    ArticleWizardButtonModule,
  ],
  exports: [
    ArticleListSpecFilterComponent
  ],
  declarations: [ArticleListComponent, ArticleListSpecFilterComponent]
})
export class ArticleListModule {
}
